import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertTriangle, MinusCircle } from "lucide-react";

const SOURCE_LABELS = {
  health_shadow:        "Health Shadow",
  outbox_shadow_metrics: "Outbox Metrics",
  safety_state:         "Safety State",
};

const STATUS_CFG = {
  available:      { label: "disponível",      cls: "bg-emerald-100 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  unavailable:    { label: "indisponível",    cls: "bg-amber-100 text-amber-700 border-amber-200",   Icon: AlertTriangle },
  not_configured: { label: "não configurado", cls: "bg-gray-100 text-gray-600 border-gray-200",      Icon: MinusCircle  },
};

export default function SourcesPanel({ sources }) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold">Fontes de Dados</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {Object.entries(SOURCE_LABELS).map(([key, label]) => {
          const state = sources[key] || "not_configured";
          const cfg = STATUS_CFG[state] || STATUS_CFG.not_configured;
          const { Icon } = cfg;
          return (
            <div key={key} className="flex items-center justify-between">
              <span className="text-sm text-gray-700">{label}</span>
              <Badge className={`text-[10px] border ${cfg.cls}`}>
                <Icon className="w-3 h-3 mr-1" />
                {cfg.label}
              </Badge>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
